import React, { useMemo } from 'react'
import { MapPinProps, MapPinTypeVariant } from '../MapPin/types'
import SvgIcon from '@mui/material/SvgIcon'
import { MapPinIcon } from '../MapPin/components/MapPinIcon'
import Box from '@mui/material/Box'

type Props = {
  variant: MapPinProps['variant']
}

const size = 27
const height = 56
const iconSize = 16.5
const count = 0

export function KeyInformationMapPin({ variant }: Props) {
  const bgColor = useMemo(() => {
    switch (variant) {
      case MapPinTypeVariant.PestPac:
        return '#002D5C'
      case MapPinTypeVariant.PendingLead:
      case MapPinTypeVariant.DraftLead:
        return '#F9BA1B'
      case MapPinTypeVariant.Opportunity:
        return '#31805B'
      case MapPinTypeVariant.Lead:
        return '#1565C0'
      case MapPinTypeVariant.Mixed:
        return '#A1C1E6'
      default:
        return '#4b2d87'
    }
  }, [variant])

  const iconColor = useMemo(() => {
    if (variant === MapPinTypeVariant.Mixed) return '#19305A'
    return 'white'
  }, [variant])

  const pinIconStyle = useMemo(() => {
    let styels: React.CSSProperties | undefined = {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '60%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      pointerEvents: 'none',
    }

    if (variant === MapPinTypeVariant.PestPac) {
      styels = {
        ...styels,
        top: '3px',
      }
    }

    if (variant === MapPinTypeVariant.Opportunity) {
      styels = {
        ...styels,
        top: '5px',
      }
    }

    if (
      variant === MapPinTypeVariant.PendingLead ||
      variant === MapPinTypeVariant.DraftLead
    ) {
      styels = {
        ...styels,
        top: '2px',
        left: '-1px',
      }
    }

    return styels
  }, [variant])

  return (
    <Box
      sx={{
        position: 'relative',
        width: size,
        height: height,
      }}
    >
      <SvgIcon
        viewBox="0 0 27 56"
        sx={{
          width: size,
          height: height,
          display: 'block',
          overflow: 'visible',
          filter: 'drop-shadow(0px 4px 6px rgba(0, 0, 0, 0.2))',
        }}
      >
        <path
          className="pin-body-path"
          d="M13.4385 0.5L25.667 16.6777C26.1553 17.3238 26.3007 18.1663 26.0566 18.9385L14.5 55.5H12.9473L0.958008 18.9277C0.705836 18.1584 0.84109 17.3142 1.32227 16.6631L13.2666 0.5H13.4385Z"
          fill={bgColor}
          stroke="white"
          strokeWidth="2"
          strokeLinejoin="round"
        />
      </SvgIcon>
      <div style={pinIconStyle}>
        <MapPinIcon
          variant={variant}
          size={iconSize}
          isGroup={count > 1}
          color={iconColor}
        />
      </div>
    </Box>
  )
}
